import { render, staticRenderFns } from "./JavaClassView.vue?vue&type=template&id=501d6264&scoped=true&"
import script from "./JavaClassView.vue?vue&type=script&lang=js&"
export * from "./JavaClassView.vue?vue&type=script&lang=js&"
import style0 from "./JavaClassView.vue?vue&type=style&index=0&id=501d6264&prod&lang=scss&scoped=true&"
import style1 from "./JavaClassView.vue?vue&type=style&index=1&id=501d6264&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501d6264",
  null
  
)

export default component.exports